import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Observable} from "rxjs/internal/Observable";
import * as fromExtraPrismaActions from '../actions/extra-prisma.actions';
import {catchError, map, switchMap} from "rxjs/operators";
import {of} from "rxjs/internal/observable/of";
import {InvoicesRestService} from "../../services/api/invoices.rest-service";
import {WebshopRestService} from "../../services/api/webshop-rest.service";
import {ProductsResponse} from '../../models/shop/products-response.model';
import {ProductType} from '../../models/shop/product-type.model';

@Injectable()
export class ExtraPrismaEffects {
    /**
     * In case of SearchInvoicesAction we're going to call the InvoicesService and then
     * we'll post a LoadInvoicesCompleteAction to the reducer or in case of failure
     * LoadInvoicesFailAction
     *
     * @type {Observable<any>}
     */
    @Effect()
    loadExtraPrisma$: Observable<any> = this.actions$
        .pipe(ofType<fromExtraPrismaActions.LoadExtraPrismaAction>(fromExtraPrismaActions.ExtraPrismaActionTypes.LOAD_EXTRAPRISMA))
        .pipe(map(action => action.payload), switchMap((productRequest) =>
            this.productRestService.loadExtraPrisma(productRequest).pipe(
                switchMap (data => {
                    const prodResp = new ProductsResponse({...data.returnObject, ...{type: ProductType.ExtraPrisma}});
                    if (productRequest.page === 1) {
                        return [new fromExtraPrismaActions.LoadExtraPrismaCompleteAction(prodResp), new fromExtraPrismaActions.GetBatchFromCacheAction()]
                    } else {
                        return [new fromExtraPrismaActions.LoadExtraPrismaCompleteAction(prodResp)]
                    }
                }),
                catchError((error) => of(new fromExtraPrismaActions.LoadExtraPrismaFailAction(error)))
            )
        ));

    @Effect()
    searchExtraPrisma$: Observable<any> = this.actions$
        .pipe(ofType<fromExtraPrismaActions.SearchShopAction>(fromExtraPrismaActions.ExtraPrismaActionTypes.SEARCH_EXTRAPRISMA))
        .pipe(map(action => action.payload), switchMap((productRequest) => [new fromExtraPrismaActions.LoadExtraPrismaAction(productRequest)]));

    /**
     * @param {InvoicesRestService} productRestService
     * @param {Actions} actions$
     */
    constructor(
        private productRestService: WebshopRestService,
        private actions$: Actions
    ) {
    }
}
